import React from 'react';
import {
  Filter,
  List,
  Edit,
  Create,
  SimpleForm,
  Datagrid,
  TextField,
  TextInput,
  EditButton,
  Responsive,
  SimpleList
} from "react-admin";

export const PredioFilter = props => {
  return (
    <Filter {...props}>
      <TextInput label="Nombre" source="searchnombre" alwaysOn autoFocus/>
    </Filter>
  )
}

const PredioNameEdit = ({ record }) => {
  return (
    <Responsive
      small={<span>Editar Predio</span>}
      medium={
        <span>Editar Predio: {record ? `"${record.nombre}"` : ""}</span>
      }
    />
  );
};

export const PredioEdit = props => (
  <Edit title={<PredioNameEdit />} {...props}>
    <SimpleForm>
      <TextInput label="Nombre" source="nombre" />
      <TextInput label="Dirección" source="direccion" />
      <TextInput label="Barrio" source="barrio" />
    </SimpleForm>
  </Edit>
);

export const PredioCreate = props => (
  <Create {...props} title="Incorporar Predio">
    <SimpleForm redirect="/predios">
      <TextInput label="Nombre" source="nombre" />
      <TextInput label="Dirección" source="direccion" />
      <TextInput label="Barrio" source="barrio" />
    </SimpleForm>
  </Create>
);

export const PredioList = props => (
  <List {...props} bulkActions={false} filters={<PredioFilter />} sort={{ field: "nombre", order: "ASC" }}>
    <Responsive
      small={
        <SimpleList
          primaryText={record => record.nombre}
          secondaryText={record => record.direccion}
          linkType="edit"
        />
      }
      medium={
        <Datagrid>
          <TextField label="Nombre" source="nombre" />
          <TextField label="Dirección" source="direccion" />
          <TextField label="Barrio" source="barrio" />
          <EditButton />
        </Datagrid>
      }
    />
  </List>
);



// WEBPACK FOOTER //
// ./src/services/predios.js